<template>
  <div class="leimonRobot padding80">
    <Header :current="0"></Header>
    <LeiMonContent :LeiMonContent="LeiMonContent"></LeiMonContent>
    <Footer></Footer>
  </div>
</template>

<script>
export default {
  name: "voiceReport",
  data() {
    return {
      LeiMonContent: {
        noTitleType: false,
        title: "语音报表",
        image: require("../../assets/content/content_voice.png"),
        tips:
          "通过语音识别功能协助员工制成报表，使用 NLP 技术完成申请资料的录入、交叉校验、摘要生成、报表生成等。",
        features: "功能特点",
        featuresEn: "FEATURES",
        list: [
          {
            title: "",
            icon: require("../../assets/content/content_voice_1.png"),
            tips:
              "使用语音输入代替繁杂的键盘输入，降低办理时间，大大提高工作效率。"
          },
          {
            title: "",
            icon: require("../../assets/content/content_voice_2.png"),
            tips: "在移动展业、资料录入等场景中使用，运用广泛。"
          }
        ]
      }
    };
  },
  created(){window,scrollTo(0,0)},
  mounted() {},
  methods: {}
};
</script>

<style scoped lang="less">
.leimonRobot {
}
</style>
